import {
  IRouterMiddleware,
  MiddlewareRoute,
  MiddlewareCallback
} from '../middleware.interface';

class ShouldHideRedirectInstance {
  constructor(
    private readonly to: MiddlewareRoute,
    private readonly from: MiddlewareRoute,
    private readonly next: MiddlewareCallback
  ) {}

  execute() {
    this.next('/');
  }
}

export class HandleShouldHideRedirect implements IRouterMiddleware {
  canActivate(to: MiddlewareRoute, from: MiddlewareRoute): boolean {
    const { navbar } = to.meta;
    return navbar && navbar.shouldHide && navbar.shouldHide();
  }

  async execute(
    to: MiddlewareRoute,
    from: MiddlewareRoute,
    next: MiddlewareCallback
  ): Promise<void> {
    const instance = new ShouldHideRedirectInstance(to, from, next);
    instance.execute();
  }
}
